import styled from 'styled-components';

interface HeroSectionVideoRootProps {
  position?: 'left' | 'right';
}

export const HeroSectionVideoRoot = styled.div<HeroSectionVideoRootProps>`
  font-family: ${props => props.theme.font};
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  direction: ${({ position = 'left' }) => position === 'right' ? 'rtl' : 'ltr'};

  > * {
    direction: ltr;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const Heading = styled.h3`
  display: flex;
  font-family: ${props => props.theme.font};
  color: ${props => props.theme.text.primary};
`;

export const FeatureText = styled.span`
  color: ${props => props.theme.text.brand};
`;

export const MainText = styled.span<{
  $isAdmin?: boolean,
}>`
  color: ${props => props.theme.text.primary};
  font-family: ${props => props.theme.font};
  margin-bottom: ${({ $isAdmin }) => ($isAdmin ? '0' : '12px')};
`;

export const Subtext = styled.p`
  color: ${props => props.theme.text.secondary};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 24px 0 12px;
  gap: 8px;
`;

export const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto 0;
  font-family: ${props => props.theme.font};

`;

export const VideoSection = styled.div<{
  $showBorder?: boolean,
}>`
  border: 1px solid ${({ $showBorder, theme }) => ($showBorder ? theme.border.decorative : 'transparent')};
  display: flex;
  flex-direction: column;
  height: auto;
  width: 100%;
  min-height: 300px;
  border-radius: 2px;

  iframe, .vimeo-player {
    aspect-ratio: 16 / 9;
    width: 100%;
    height: 100%;
    border: none;
  }
`;
